import React, { useContext, useRef, useEffect } from "react";
import { motion } from 'framer-motion'
import { FaUser } from "react-icons/fa";
import { CiSearch} from "react-icons/ci";
import {RecipeContext} from "../context/RecipeContext"
import { useNavigate , useLocation} from "react-router-dom";
import HomeNav from "./HomeNav"
import Categorys from "./Categorys"
import { useState } from "react";
export default function Header() {

  const [nav , setNav]= useState(<nav></nav>)
 
  const location = useLocation();
 
  useEffect(() => {

      if(location.pathname === "/" ) {
     
        setNav(<HomeNav/>)
      } else if(location.pathname.includes("explore")){
        setNav(<Categorys/>)
      } else {
        setNav(<nav/>)
      }
    
  
  
   
  }, [location.pathname])
  
  const { user, setShowNav, showNav , setShowLogin} = useContext(RecipeContext);
  const searchInp = useRef();
  const headerRef = useRef();
  const navigate = useNavigate();
  function shrink() {
    headerRef.current.classList.add("shrink");
  }
   function hideSearch (){
    headerRef.current.classList.remove("shrink");
  }
  function search(e) {
    
    e.preventDefault();
    if (searchInp.current.value !== "") {
      navigate("/explore/query=" + searchInp.current.value);
    }
  }

  return (
    <motion.header ref={headerRef}
      initial={{ y: -250 }}
      animate={{ y: -10 }}
      transition={{ delay: 0.2 }}
    >
      <div
        className="nav-btn"
        onClick={() => {
          setShowNav(!showNav);
        }}
      >
        <span></span>
        <span></span>
      </div>
      <div className="welckom">
        <h4>Hello {user ? user.displayName : "Esther"}!! 👋</h4>
        <p>Let's make something new today!</p>
      </div>

      {nav}

      <form className="search-box" onSubmit={search}>
        <button className="center" type="button">
          <CiSearch />
        </button>
        <input
          type="text"
          placeholder="Search anything here..."
          id="searchInp"
          ref={searchInp}
          onFocus={shrink}
          onBlur={hideSearch}
        />
      </form>
      {user ?
      <div className="user-icon center">
         <img src={user.photoURL} alt={user.displayName[0]}/>
      </div>
       :  
       <div className="user-icon center" onClick={()=>setShowLogin(true)} style={{cursor:"pointer"}}>
        <FaUser />
      </div>}
    </motion.header>
  );
}
